import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';

export default class GameWinned extends BaseScene {

    private score = 0;
    private levelId = 0;
    private totalScore = 0;
    private topScores: any[] = []; 
    private bestScore = 0;
    private container: any;

    constructor() {
        super({key: 'GameWinned'});
    }

    public init(data: any) {
        super.init();

        this.score = Math.round(data.score);
        this.levelId = data.levelId;

        this.getBootloaderScene().completeLevel(this.levelId, this.score);
        this.totalScore = this.getBootloaderScene().AppData.totals.score;
        const levelSaved = this.getBootloaderScene().AppData.levels.find(item => item.id === this.levelId);
        this.bestScore = levelSaved ? levelSaved.score : 0;
        this.topScores = this.getBootloaderScene().AppData.levelScores[this.levelId] ?? [];
    }

    public create() {
        super.create();

        // Music
        this.getBootloaderScene().soundManager.playWinMusic();  

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);
        
        // Panel
        const panel = this.add.image(0, 0,'game_panel_main_big_01');

        const title = this.add.text(0, -246, translate.key('game_winned_title'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 56,
                color: '#fff'
            })
            .setStroke('#212121', 6);


        const levelDescription = this.add.text(0, -110, `${translate.key('Level')} ${this.levelId} ${translate.key('Completed')}`)
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 26,
                color: '#666'
            });

        const scoreTitle = this.add.text(0, -50, translate.key('game_winned_text_1'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 26,
                color: '#3d3d3d'
            });

        const scoreText = this.add.text(0, 0, this.score.toString())
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 50,
                color: '#08789c'
            });

        const bestScoreText = this.add.text(0, 70, `${translate.key('game_winned_text_2')}: ` + this.bestScore.toString())
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 24,
                color: '#666',
                align: 'center',
            });

        const totalScoreText = this.add.text(0, 100,  `${translate.key('game_winned_text_3')}: ` + this.totalScore.toString())
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 24,
                color: '#666',
                align: 'center',
            });

        const replayButton = new ButtonSprite(this, -95, 215, 'button_replay', 2, () => this.replayGame());

        const nextButton = new ButtonSprite(this, 95, 215, 'button_next', 2,() => this.nextGame());

        const menuButton = new ButtonSprite(this, 2, 215, 'button_menu', 2, () => this.exitToMenu());

        const rankingPanel = this.add.image(0, 430,'game_panel_info_small');

        const rankingTitle = this.add.text(0, 380, `${translate.key('Top')}`)
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 24,
                color: '#666'
            });

        this.container = this.add.container(this.width / 2, -300).add([panel, title, levelDescription, scoreTitle, scoreText, bestScoreText, totalScoreText, replayButton, nextButton, menuButton, rankingPanel, rankingTitle]);

        // Top List
        this.topScores.forEach((score: any, index: integer) => {

            const nameText = this.add.text(-80, (index * 25) + 400, score.name)
                .setStyle({ 
                    fontFamily: 'supersonic',
                    fontSize: 17,
                    color: '#08789c',
                    align: 'left'
                });

            const scorePoints = this.add.text(50, (index * 25) + 400, score.score)
                .setWordWrapWidth(320)
                .setStyle({ 
                    fontFamily: 'soupofjustice',
                    fontSize: 22,
                    color: '#696969',
                });

            this.container.add([nameText, scorePoints]);
        });

        // Tween
        this.tweens.add({
            y: 370,
            targets: this.container,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });

    }

    private nextGame() {
        if (this.levelId == 70) {
            this.getBootloaderScene().launchScene('EndGame');
            return;
        }

        this.getBootloaderScene().launchScene('LevelSelector');
        this.getBootloaderScene().scene.pause('LevelSelector');
        this.getBootloaderScene().scene.launch('LevelSelectorInfo', {levelId: this.levelId + 1});
        this.getBootloaderScene().scene.bringToTop('LevelSelectorInfo');
    }

    private replayGame() {
        this.getBootloaderScene().launchScene('GameLevel');
    }

    private exitToMenu() {
        this.getBootloaderScene().launchScene('MainMenu');
    }
}
